import Vue from 'vue'

const SET_DATA = (context, data) => {
  context[data.store][data.state] = data.data
}

const ADD_DATA = (context, data) => {
  context[data.store][data.state].push(data.data)
}

const UPDATE_DATA = (context, data) => {
  let index = context[data.store][data.state].findIndex(e => e.id === data.data.id)
  if (index !== -1) {
    context[data.store][data.state].splice(index, 1, data.data)
  }
}

const DELETE_DATA = (context, data) => {
  context[data.store][data.state] = context[data.store][data.state].filter(i => i.id !== data.data)
}

const DELETE_DATA_TOKEN = (context, data) => {
  console.log(context[data.store][data.state].results.filter(i => i.pk_md5 !== data.data), 'data')
  context[data.store][data.state].results = context[data.store][data.state].results.filter(i => i.pk_md5 !== data.data)
}

const ADD_PASSPORT_TO_CLIENTS = (context, data) => {
  let client = context[data.store][data.state].find(i => i.id === data.data.id)

  Vue.set(client, 'passport', data.data.passport)
}

const CLEAR_INSPECTION = context => {
  context.inspection.inspection = {}
  context.inspection.dependency = {}
  context.inspection.decisionIssue = {}
  context.inspection.certificate = {}
  context.inspection.lightTransmissionMeasurement = []
  context.inspection.lightMeasurement = {}
  context.inspection.brakeMeasurement = {}
  context.inspection.gasMeasurement = []
  context.inspection.smokeMeasurement = []
  context.inspection.noiseMeasurement = {}
  context.inspection.questions = []
  context.inspection.vehicle = []
  context.inspection.proofs = []
}

export default {
  SET_DATA, DELETE_DATA, ADD_DATA, UPDATE_DATA, ADD_PASSPORT_TO_CLIENTS, DELETE_DATA_TOKEN,
  CLEAR_INSPECTION
}
